import Utils from "../utils/Utils";
const VendorOrderController = {
  getPendingOrders: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/vendorOrder/v1/getPendingOrders",
      {},
      "GET",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },
  getOrdersDashboard: ({
    Authorization,
    companyId,
    view,
    selectedOrderId,
    fromDate,
    toDate,
    page,
    size,
  }) => {
    const params = new URLSearchParams();
    if (companyId) params.append("companyId", companyId);
    if (view) params.append("view", view);
    if (selectedOrderId) params.append("selectedOrderId", selectedOrderId);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (page !== undefined && page !== null) params.append("page", page);
    if (size !== undefined && size !== null) params.append("size", size);

    return Utils.controller(
      "api/vendorOrder/v1/getOrdersDashboard",
      {},
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  getOrderDetails: ({ Authorization, companyId, orderId }) => {
    return Utils.controller(
      "api/vendorOrder/v1/getOrderDetails",
      {},
      "GET",
      `companyId=${companyId}&orderId=${orderId}`,
      true,
      Authorization,
      true,
    );
  },
  acceptOrder: ({ Authorization, orderId }) => {
    return Utils.controller(
      "api/vendorOrder/v1/acceptOrder",
      {},
      "POST",
      `orderId=${orderId}`,
      true,
      Authorization,
      true,
    );
  },
  rejectOrder: ({ Authorization, orderId }) => {
    return Utils.controller(
      "api/vendorOrder/v1/rejectOrder",
      {},
      "POST",
      `orderId=${orderId}`,
      true,
      Authorization,
      true,
    );
  },
  updateStatus: ({ Authorization, request }) => {
    return Utils.controller(
      "api/vendorOrder/v1/updateStatus",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
};
export default VendorOrderController;
